import { render, staticRenderFns } from "./ChangeProduct.vue?vue&type=template&id=562ef5fa"
import script from "./ChangeProduct.vue?vue&type=script&lang=js"
export * from "./ChangeProduct.vue?vue&type=script&lang=js"
import style0 from "./ChangeProduct.vue?vue&type=style&index=0&id=562ef5fa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports